import { rem } from 'polished';
import { layoutTheme } from '~layout';
var breakpoints = ["" + rem(layoutTheme.layout.media.xxs), "" + rem(layoutTheme.layout.media.xs), "" + rem(layoutTheme.layout.media.sm), "" + rem(layoutTheme.layout.media.md), "" + rem(layoutTheme.layout.media.lg), "" + rem(layoutTheme.layout.media.xl)];
var baselineTheme = {
  lightMode: {
    breakpoints: breakpoints
  },
  darkMode: {
    breakpoints: breakpoints
  }
};
export default baselineTheme;